/**
 * Where the guided demo tour lives: the create-task wizard opened with
 * `?tour=demo`. The wizard reads this flag to run as a pure client-side mock
 * (no API calls, nothing persisted) driven by the `create_model` walkthrough.
 */
export const DEMO_TOUR_QUERY_PARAM = 'tour';
export const DEMO_TOUR_QUERY_VALUE = 'demo';
export const DEMO_TOUR_PATH = `/create-task?${DEMO_TOUR_QUERY_PARAM}=${DEMO_TOUR_QUERY_VALUE}`;

/** True when a router `search` string (or `URLSearchParams`) asks for the demo tour. */
export const isDemoTourSearch = (search) => {
    const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
    return params.get(DEMO_TOUR_QUERY_PARAM) === DEMO_TOUR_QUERY_VALUE;
};
